import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cib' })
export class CibPipe implements PipeTransform {
  /**
   * Formata o identificador CIB.
   * 
   * @param cib Identificador CIB com o dígito verificador no final.
   * @returns Retorna o CIB formatado no seguinte padrão "AAAAAAA-D".
   */
  transform(cib: string) {
    if (cib == null) {
      return "";
    }

    const cibRaw = cib.toString().replace(/[^\d\w]/g, "").padStart(8, "0");
    return `${cibRaw.substring(0, 7)}-${cibRaw.substring(7)}`;
  }
}